import React, { Component } from "react";
import consts from "../utils/constants";
import axios from "axios";

import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { CancelableEvents } from "browser-cancelable-events";
import { Link as Scroll } from "react-scroll";
import { Link } from "react-router-dom";
import Icofont from "react-icofont";
import SideNav from "../components/SideNav";

class NavBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSticky: false,
      address: "",
      complement: "",
      district: "",
      cep: "",
      city: "",
      state: "",
      email: "",
      phone: "",
    };

    this.addSticky = this.addSticky.bind(this);
    this.cancelable = new CancelableEvents();
  }

  addSticky = (elem) => {
    if (window.scrollY > 170) {
      elem.classList.add("is-sticky");
      this.setState({ ...this.state, isSticky: true });
    } else {
      elem.classList.remove("is-sticky");
      this.setState({ ...this.state, isSticky: false });
    }
  };

  componentDidMount() {
    let elem = document.getElementById("navbar");
    this.cancelable.addDocumentEventListener("scroll", () =>
      this.addSticky(elem)
    );

    axios.get(consts.getSitePageUrl()).then((resp) =>
      this.setState({
        ...this.state,
        address: resp.data.data.site.address,
        complement: resp.data.data.site.complement,
        district: resp.data.data.site.district,
        cep: resp.data.data.site.cep,
        city: resp.data.data.site.city,
        state: resp.data.data.site.state,
        email: resp.data.data.site.email,
        phone: resp.data.data.site.phone_number,
      })
    );
  }

  componentWillUnmount() {
    this.cancelable.cancelAll();
  }

  closeNavbar() {
    if (window.matchMedia("screen and (max-width: 991px)").matches) {
      document.getElementById("collaspe-btn").click();
    }
  }

  render() {
    const condicoesGeraisUrl =
      consts.STORAGE_URL + "/condicoes_gerais/uniao_seguradora/";

    return (
      <React.Fragment>
        <Navbar
          sticky="top"
          id="navbar"
          bg="light"
          expand="xl"
          className="navbar navbar-expand-xl navbar-light bg-light"
          collapseOnSelect={true}
        >
          <Container>
            <Navbar.Brand>
              <Scroll
                to="home"
                spy={true}
                smooth={true}
                offset={-150}
                duration={800}
              >
                {this.state.isSticky ? (
                  <img src={this.props.logo} alt={`Logo ${this.props.site}`} />
                ) : (
                  <img
                    src={this.props.logoNegativo}
                    alt={`Logo ${this.props.site}`}
                  />
                )}
              </Scroll>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" id="collaspe-btn" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="ml-auto">
                <Nav.Item>
                  <Scroll
                    activeClass="active1"
                    to="home"
                    spy={true}
                    smooth={true}
                    offset={-150}
                    duration={800}
                    className="nav-link"
                    onClick={this.closeNavbar}
                  >
                    Home
                  </Scroll>
                </Nav.Item>
                <Nav.Item>
                  <Link
                    to="/sobre"
                    className="nav-link"
                    onClick={this.closeNavbar}
                  >
                    A Empresa
                  </Link>
                </Nav.Item>
                <Nav.Item>
                  <Scroll
                    activeClass="active1"
                    to="services"
                    spy={true}
                    smooth={true}
                    offset={-110}
                    duration={800}
                    className="nav-link"
                    onClick={this.closeNavbar}
                  >
                    Produtos
                  </Scroll>
                </Nav.Item>
                <Nav.Item>
                  <Scroll
                    activeClass="active1"
                    to="news"
                    spy={true}
                    smooth={true}
                    offset={-120}
                    duration={800}
                    className="nav-link"
                    onClick={this.closeNavbar}
                  >
                    Notícias
                  </Scroll>
                </Nav.Item>
                <Nav.Item>
                  <Scroll
                    activeClass="active1"
                    to="contact"
                    spy={true}
                    smooth={true}
                    offset={-100}
                    duration={800}
                    className="nav-link"
                    onClick={this.closeNavbar}
                  >
                    Contato
                  </Scroll>
                </Nav.Item>
                <NavDropdown title="Condições Gerais" id="basic-nav-dropdown">
                  <NavDropdown.Item
                    href={condicoesGeraisUrl + "CG_VG_UNIAO_102013.pdf"}
                    target="_blank"
                  >
                    Seguro de Vida em Grupo
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    href={condicoesGeraisUrl + "CG_APC_UNIAO_072013.pdf"}
                    target="_blank"
                  >
                    Seguro de Acidentes Pessoais
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    href={condicoesGeraisUrl + "CG_PREST_UNIAO_102013.pdf"}
                    target="_blank"
                  >
                    Seguro Prestamista
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    href={condicoesGeraisUrl + "CG_AF_UNIAO_072013.pdf"}
                    target="_blank"
                  >
                    Seguro de Auxílio Funeral
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/seguro-viagem">
                    Seguro Viagem
                  </NavDropdown.Item>
                </NavDropdown>
                <Nav.Item>
                  <a href={consts.PORTAL_CLIENTE_URL} className="nav-link">
                    <Icofont icon="lock" />
                    Portal do Cliente
                  </a>
                </Nav.Item>
                <Nav.Item>
                  <SideNav
                    page={this.props.page}
                    logo={consts.LOGO_UNIAO_SEGURADORA}
                    site={consts.APP_NAME_UNIAO_SEGURADORA}
                    locationbolt={
                      this.state.address + " - " + this.state.complement
                    }
                    locationnormal={
                      this.state.district +
                      ", " +
                      this.state.cep +
                      ", " +
                      this.state.city +
                      "/" +
                      this.state.state
                    }
                    phonebolt={this.state.phone}
                    mailbolot={this.state.email}
                    hasSocialLinks={true}
                    facebooklink="http://www.facebook.com/grupoaspecir/"
                  />
                </Nav.Item>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </React.Fragment>
    );
  }
}

export default NavBar;
